<template>
    <SupplierEmailsDialog :show="show" :title="title" :subtitle="subtitle" :items="items" :event="emailEvent"
        :note="note" @close="$emit('close')" @sent="$emit('sent', $event)" />
</template>

<script>
import { mapGetters } from "vuex"
import SupplierEmailsDialog from './SupplierEmailsDialog.vue'
import { buildChangeEmail, changeService, CHANGE_EMAIL_KINDS, escapeHtml } from '@/utils/supplierChangeEmails'

// The prompt after an edit that changed booked suppliers' bookings: `changes` is the
// supplier_changes an API call returned (SupplierChangeService::diff). Shown whenever it lists
// any supplier; suppliers already contacted are ticked, the rest are listed unticked.
export default {
    components: { SupplierEmailsDialog },
    props: {
        // [] from the API when there's nothing to send.
        changes: { type: [Object, Array], default: null },
        // The loaded event, when there is one: sent with the email for its logo and branding.
        event: { type: Object, default: null },
    },
    computed: {
        ...mapGetters({
            get_user: 'auth/get_user',
            get_selected_company: 'auth/get_selected_company',
        }),
        show() {
            return !!(this.changes && this.changes.suppliers && this.changes.suppliers.length)
        },
        emailEvent() {
            return this.event || (this.changes && this.changes.event) || {}
        },
        title() {
            return this.changes && this.changes.kind === 'date_change'
                ? 'Email Suppliers About the Date Change'
                : 'Email Suppliers About the Booking Changes'
        },
        subtitle() {
            return 'These suppliers\' bookings changed. Check each email, untick any supplier you don\'t want to email, then send.'
        },
        items() {
            if (!this.show) return []
            const options = {
                event: { ...(this.changes.event || {}), ...(this.event || {}) },
                company: this.get_selected_company,
                advisorName: this.get_user ? this.get_user.name : '',
                oldStartDate: this.changes.old_start_date,
                newStartDate: this.changes.new_start_date,
            }
            return this.changes.suppliers.map(notice => ({
                key: notice.supplier.id,
                supplier: notice.supplier,
                selected: notice.contacted,
                contacted: notice.contacted,
                email_type: notice.kind,
                summary: CHANGE_EMAIL_KINDS[notice.kind] || 'Change',
                // Each change is a service staff can untick; the email is rebuilt from the rest.
                services: notice.changes.map((change, index) => changeService(change, index)),
                compose: (ids) => {
                    const changes = notice.changes.filter((change, index) => ids.includes(index))
                    const build_ids = [...new Set(changes.map(change => change.build_id).filter(Boolean))]
                    const { subject, body } = buildChangeEmail({ ...notice, changes, build_ids }, options)
                    return { subject, body, build_ids }
                },
            }))
        },
        note() {
            if (!this.show) return ''
            const parts = []
            if (this.changes.new_suppliers && this.changes.new_suppliers.length) {
                parts.push(`<b>New suppliers to book:</b> ${this.changes.new_suppliers.map(escapeHtml).join(', ')}. Send their booking request from the event's Suppliers tab.`)
            }
            parts.push('Closed this without sending? You can send these emails later from the event\'s Suppliers tab → <b>Email Suppliers</b>.')
            return parts.join('<br><br>')
        },
    },
}
</script>
